import React from "react";
import { createUseStyles } from "react-jss";
import unsafeHTML from "../../../utils/unsafeHTML";
import Typography from "../../Typography";
import Button from "../../common/Button";
var LeftAlign = function (_a) {
    var backgroundColor = _a.backgroundColor, buttonColor = _a.buttonColor, buttonLink = _a.buttonLink, buttonTarget = _a.buttonTarget, buttonText = _a.buttonText, buttonTextColor = _a.buttonTextColor, header = _a.header, subImage = _a.subImage, subText = _a.subText, textColor = _a.textColor, topImage = _a.topImage;
    var useStyles = createUseStyles(function (theme) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return ({
            root: (_a = {
                    display: "block",
                    position: "relative",
                    width: "100%",
                    height: "auto",
                    margin: "0 auto",
                    backgroundColor: backgroundColor,
                    padding: "0 15px",
                    color: textColor || "inherit"
                },
                _a[theme.mediaQuery(theme.breakpoints.medium)] = {
                    display: "flex",
                    flexFlow: "row nowrap",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 0,
                },
                _a),
            contentContainer: (_b = {
                    padding: "12px 15px 24px",
                    flex: "0 1 50%",
                    display: "flex",
                    position: "relative",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                },
                _b[theme.mediaQuery(theme.breakpoints.small)] = {
                    padding: "0 0 0 36px",
                    alignItems: "flex-start",
                },
                _b),
            imageContainer: {
                flex: "0 1 50%",
            },
            hideDesktop: (_c = {
                    display: "block"
                },
                _c[theme.mediaQuery(theme.breakpoints.small)] = {
                    display: "none",
                },
                _c),
            hideMobile: (_d = {
                    display: "none"
                },
                _d[theme.mediaQuery(theme.breakpoints.medium)] = {
                    display: "block",
                },
                _d),
            headline: (_e = {
                    margin: "24px auto",
                    textAlign: "center",
                    maxWidth: "300px",
                    display: "block",
                    position: "relative",
                    color: textColor || "inherit"
                },
                _e[theme.mediaQuery(theme.breakpoints.medium)] = {
                    fontSize: theme.typography.heading2.fontSize,
                    textAlign: "left",
                    maxWidth: "100%",
                    margin: "24px 0 12px",
                },
                _e),
            subText: (_f = {
                    lineHeight: "20px",
                    maxWidth: "400px",
                    margin: "24px auto 48px",
                    display: "block",
                    position: "relative",
                    color: textColor || "inherit"
                },
                _f[theme.mediaQuery(theme.breakpoints.medium)] = {
                    fontSize: theme.typography.heading4.fontSize,
                    lineHeight: "40px",
                    textAlign: "left",
                    maxWidth: "1000px",
                    margin: "24px 0 48px",
                },
                _f),
            topImage: (_g = {
                    display: "block",
                    margin: "0 auto 20px",
                    maxWidth: "275px"
                },
                _g[theme.mediaQuery(theme.breakpoints.medium)] = {
                    margin: 0,
                    position: "relative",
                    maxWidth: "700px",
                },
                _g),
            sideImage: (_h = {
                    margin: "0 auto",
                    display: "block",
                    position: "relative",
                    maxWidth: "275px"
                },
                _h[theme.mediaQuery(theme.breakpoints.medium)] = {
                    maxWidth: "100%",
                    maxHeight: "100%",
                },
                _h),
            buttonContainer: (_j = {
                    width: "100%"
                },
                _j[theme.mediaQuery(theme.breakpoints.medium)] = {
                    width: "auto",
                },
                _j),
        });
    });
    var classes = useStyles();
    return (React.createElement("div", null,
        React.createElement("div", { className: classes.root },
            React.createElement("div", { className: classes.contentContainer },
                React.createElement("div", { className: classes.hideDesktop },
                    React.createElement("img", { "data-testid": "subImage", className: classes.sideImage, src: subImage.fields.file.url, alt: "", role: "presentation" })),
                React.createElement("div", null,
                    React.createElement("img", { "data-testid": "topImage", src: topImage.fields.file.url, className: classes.topImage, alt: "", role: "presentation" })),
                React.createElement(Typography, { className: classes.headline, variant: "heading2", dangerouslySetInnerHTML: unsafeHTML(header) }),
                React.createElement(Typography, { className: classes.subText, variant: "heading6", dangerouslySetInnerHTML: unsafeHTML(subText) }),
                React.createElement("div", { className: classes.buttonContainer },
                    React.createElement(Button, { buttonLink: buttonLink, buttonColor: buttonColor, buttonText: buttonText, buttonTarget: buttonTarget, buttonTextColor: buttonTextColor }))),
            React.createElement("div", { className: classes.imageContainer },
                React.createElement("div", { className: classes.hideMobile },
                    React.createElement("img", { className: classes.sideImage, src: subImage.fields.file.url, alt: "" }))))));
};
export default LeftAlign;
